
import React from 'react';

interface EstimateHeaderProps {
  company: {
    name: string;
    logo_url?: string;
    street_address?: string;
    suburb?: string;
    city?: string;
    province_state?: string;
    postal_code?: string;
    company_phone_number?: string;
    email?: string;
    is_vat_registered?: boolean;
    vat_number?: string;
  };
  userProfile?: {
    personal_phone_number?: string;
  } | null;
}

const EstimateHeader: React.FC<EstimateHeaderProps> = ({ company, userProfile }) => {
  // Helper to format phone number as xxx xxx xxxx
  const formatPhoneNumber = (phone: string | undefined): string => {
    if (!phone) return '';
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length >= 10) {
      return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6, 10)}`;
    }
    return phone;
  };

  // Build address lines for stacking
  const addressLines = [
    company.street_address,
    company.suburb,
    company.city,
    company.postal_code,
  ].filter(Boolean);

  return (
    <div style={{ width: '100%', marginBottom: '32px', display: 'flex' }}>
      {/* First two columns empty */}
      <div style={{ width: '33%' }}></div>
      <div style={{ width: '33%' }}></div>
      <div style={{ width: '34%', textAlign: 'left' }}>
        {/* Company Name */}
        <div
          style={{
            fontWeight: 700,
            fontSize: '20px',
            color: '#13304a',
            marginBottom: '16px',
            marginTop: '6px',
            letterSpacing: '-0.5px'
          }}
        >
          {company.name}
        </div>
        {/* Address block */}
        <div style={{ fontSize: '14px', color: '#111', lineHeight: 1.45, marginBottom: '7px' }}>
          {addressLines.map((line, idx) => (
            <div key={idx}>{line}</div>
          ))}
        </div>
        {/* VAT number */}
        {!!company.is_vat_registered && company.vat_number && (
          <div style={{ margin: '7px 0', fontWeight: 700, color: '#222', fontSize: '14px' }}>
            VAT No: <span style={{ fontWeight: 400 }}>{company.vat_number}</span>
          </div>
        )}
        {/* Company Tel */}
        {company.company_phone_number && (
          <div style={{ margin: '7px 0', fontWeight: 700, fontSize: '14px' }}>
            Tel: <span style={{ fontWeight: 400 }}>{formatPhoneNumber(company.company_phone_number)}</span>
          </div>
        )}
        {/* User Cell */}
        {userProfile?.personal_phone_number && (
          <div style={{ margin: '7px 0', fontWeight: 700, fontSize: '14px' }}>
            Cell: <span style={{ fontWeight: 400 }}>{formatPhoneNumber(userProfile.personal_phone_number)}</span>
          </div>
        )}
        {/* Email */}
        {company.email && (
          <div style={{ margin: '7px 0', fontWeight: 700, fontSize: '14px' }}>
            Mail: <span style={{ fontWeight: 400 }}>{company.email}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EstimateHeader;
